import React from 'react';
import { ProviderService } from '../../../api/Providers/Services';

export const PopularServicesContext = React.createContext<ProviderService[]>([]);
export const PreviouslyBookedServicesContext = React.createContext<ProviderService[]>([]);
